import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";
import { homeForRole } from "../lib/roles";
import { LumiMascot } from "../components/Brand";

/**
 * Emergent-managed Google auth callback.
 * URL fragment format: /auth/callback#session_id=<id>
 * Runs synchronously on first mount (uses a ref to guard against StrictMode double-invoke).
 */
export default function AuthCallback() {
  const { completeGoogleSession } = useAuth();
  const nav = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      toast.error("Google sign-in was cancelled or failed.");
      nav("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);
    // Clean the fragment so a refresh doesn't retry.
    if (window.history.replaceState) {
      window.history.replaceState({}, "", window.location.pathname);
    }

    completeGoogleSession(sessionId)
      .then((user) => {
        toast.success(`Welcome, ${user.full_name}!`);
        nav(homeForRole(user.role), { replace: true });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail || "Google sign-in failed.");
        nav("/login", { replace: true });
      });
  }, [completeGoogleSession, nav]);

  return (
    <div className="min-h-screen student-bg flex items-center justify-center p-6">
      <div className="text-center">
        <LumiMascot size={140} className="mx-auto lumi-bounce" />
        <div className="font-adult font-bold text-2xl text-slate-900 mt-4">
          Signing you in…
        </div>
        <p className="text-slate-600 text-sm mt-1">Just a moment while we set up your account.</p>
      </div>
    </div>
  );
}
